import React, { useState } from "react";
import { Link } from "react-router-dom";

import svg1 from "./img/svg1.svg";
import svg2 from "./img/svg2.svg";
import svg3 from "./img/svg3.svg";
import svg4 from "./img/svg4.svg";

const BookWithUs = () => {
  return (
    <>
      <section className=" bg-light py-5">
        <div className="container mb-5">
          <div className="text-start">
            <h1>Why book with us?</h1>
          </div>
          <div className="row g-3">
            <div className="col-md-3 ">
              <div className="bg-white img3 p-3">
                <div>
                  <img src={svg1} alt="" className="img-fluid " />
                </div>
                <div className="py-3">
                  <div className="txt1">
                    <strong>Easy Booking</strong>
                  </div>
                  <div className="text-muted">
                    We offer easy and convenient flight bookings with attractive
                    offers.
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-3 ">
              <div className="bg-white img3 p-3">
                <div>
                  <img src={svg2} alt="" className="img-fluid " />
                </div>
                <div className="py-3">
                  <div className="txt1">
                    <strong>Lowest Price</strong>
                  </div>
                  <div className="text-muted">
                    We ensure low rates on hotel reservation, holiday packages
                    and on flight tickets.
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-3 ">
              <div className="bg-white img3 p-3">
                <div>
                  <img src={svg3} alt="" className="img-fluid " />
                </div>
                <div className="py-3">
                  <div className="txt1">
                    <strong>Exciting Deals</strong>
                  </div>
                  <div className="text-muted">
                    Enjoy exciting deals on flights, hotels, buses, car rental
                    and tour packages.
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-3 ">
              <div className="bg-white img3 p-3">
                <div>
                  <img src={svg4} alt="" className="img-fluid " />
                </div>
                <div className="py-3">
                  <div className="txt1">
                    <strong>24/7 Support</strong>
                  </div>
                  <div className="text-muted">
                    Get assistance 24/7 on any kind of travel related query. We
                    are happy to assist you.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default BookWithUs;
